import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Redirect, Switch } from "react-router-dom";
import 'moment/locale/zh-cn';
import './index.less';
import asyncComponent from './components/async-component';
import PrintSafetyRecord from './pages/home/PrintSafetyRecord';
import PrintFireRecord from './pages/fire/PrintFireRecord';
import PrintFireRecordHui from './pages/fire/PrintFireRecordHui';
import PrintSafetyRecordHui from './pages/home/PrintSafetyRecordHui';
import PrintQfRecord from './pages/qfcheck/PrintQfRecord';
import PrintQfRecordHui from './pages/qfcheck/PrintQfRecordHui';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';

const placeholder = <span style={{ position: 'fixed', width: '100%', height: '100%', display: 'flex', alignItems: 'center', 'justifyContent': 'center' }}>loading……</span>


const PageLogin = asyncComponent(() => import('./pages/login'), placeholder);
const PageHome = asyncComponent(() => import('./pages/home'), placeholder);
const PageCompany = asyncComponent(() => import('./pages/company'), placeholder); 
const PageFire = asyncComponent(() => import('./pages/fire'), placeholder);

const PageAdmin = asyncComponent(() => import('./pages/admin'), placeholder);
const PageSystemLogs = asyncComponent(() => import('./pages/systemLogs'), placeholder);
const PagePermission = asyncComponent(() => import('./pages/permission'), placeholder);
const PageRole = asyncComponent(() => import('./pages/role'), placeholder);
const PageApk = asyncComponent(() => import('./pages/apk'), placeholder);
const PageLaw = asyncComponent(() => import('./pages/law'), placeholder);
const PageCtype = asyncComponent(() => import('./pages/ctype'), placeholder);
const PageStype = asyncComponent(() => import('./pages/supervise'), placeholder);
const PageQfCheck = asyncComponent(() => import('./pages/qfcheck'), placeholder);
const PageWeekPlan = asyncComponent(() => import('./pages/weekplan'), placeholder);
const PageDelete = asyncComponent(() => import('./pages/delete'), placeholder);
const PageBigData = asyncComponent(() => import('./pages/bigpage'), placeholder);
moment.locale('zh-cn');


const App = () => (
  <ConfigProvider locale={zhCN}>
    <Router>
      <Switch>
        <Route exact path="/"><PageCompany /></Route>
        <Route exact path="/check"><PageHome /></Route>
        <Route exact path="/print/safety-record"><PrintSafetyRecord /></Route>
        <Route exact path="/print/fire-record"><PrintFireRecord /></Route>
        <Route exact path="/print/safety-recordhui"><PrintSafetyRecordHui /></Route>
        <Route exact path="/print/fire-recordhui"><PrintFireRecordHui /></Route>
        <Route exact path="/print/qf-record"><PrintQfRecord /></Route>
        <Route exact path="/print/qf-recordhui"><PrintQfRecordHui /></Route>
        <Route exact path="/fire"><PageFire /></Route>
        <Route exact path="/delete"><PageDelete /></Route>
        <Route exact path="/qfcheck"><PageQfCheck /></Route>
        <Route exact path="/weekplan"><PageWeekPlan /></Route>
        <Route exact path="/login"><PageLogin /></Route>
        <Route exact path="/admin/list"><PageAdmin /></Route>
        <Route exact path="/logs/list"><PageSystemLogs /></Route>
        <Route exact path="/apk/version"><PageApk /></Route>
        <Route exact path="/law/list"><PageLaw /></Route>
        <Route exact path="/ctype/list"><PageCtype /></Route>
        <Route exact path="/supervise/list"><PageStype /></Route>
        <Route exact path="/permission/list"><PagePermission /></Route>
        <Route exact path="/role/list"><PageRole /></Route>
        <Route exact path="/bigdata"><PageBigData /></Route>
        <Route render={() => (<Redirect to="/result/404" />)} />
      </Switch>
    </Router>
  </ConfigProvider>
 
);

ReactDOM.render(<App />, document.getElementById('root'));
